module.exports = __webpack_public_path__ + "img/poster_TH.19d370df.png";